document.addEventListener('DOMContentLoaded', () => {
    const slides = document.querySelectorAll('.hero .slide');
    slides.forEach((slide) => {
        slide.addEventListener('click', function (e) {
            if (!slide.classList.contains('active')) {
                e.preventDefault();
                slides.forEach(s => s.classList.remove('active'));
                slide.classList.add('active');
            }
        });
    });
});